import { MultiViewsElementCustom, PrintUtilsBase, RotateCameraType, SelectedApexMech, StateTypes, TempDataToRestore, ViewType } from "@ortho-next/nextray-core";
import { Vector2 } from "three";
import { Main } from "../Core/Main";
import { bindedModel } from "../Models/BindedModel";
import { Context } from "../States/Context";
import { PrintStateTypes } from "../States/State";

export type ViewPlanImages = { deformity: string, templating: string; };

/**
 * Generates ViewPlan images.
 */
export class ViewPlanUtils extends PrintUtilsBase {
	protected declare _main: Main;
	protected declare _context: Context;

	constructor(main: Main, context: Context) {
		super(main, context);
	}

	public generateImages(stateType: StateTypes, resolution: Vector2): ViewPlanImages {
		const printResult: ViewPlanImages = { deformity: "", templating: "" };
		const tempData: TempDataToRestore = {};
		const renderMultipleView = this._main.hasAP && this._main.hasLT;

		this.getRestoreData(tempData);

		if (renderMultipleView) {
			this._main.multiViewsActive = true;
		}

		bindedModel.isViewPlan = true;

		const model = this._main.model;
		model.isAPMechanicalAxisInserted = bindedModel.isMechanicalAxisAPValid;
		model.isLTMechanicalAxisInserted = bindedModel.isMechanicalAxisLTValid;
		model.isContralateralAxisInserted = bindedModel.isControlateralMechanicalAxisValid;

		this.applyResize(resolution.x, resolution.y);
		this._main.renderer.setPixelRatio(1);

		if (renderMultipleView) {
			(this._main.multiviewRenderer.viewsports[ViewType.AP] as MultiViewsElementCustom).cameraControls.fitToPlane();
			(this._main.multiviewRenderer.viewsports[ViewType.LT] as MultiViewsElementCustom).cameraControls.fitToPlane();
		} else {
			if (this._main.hasAP) this._main.scenes[ViewType.AP].cameraControls.fitToPlane();
			if (this._main.hasLT) this._main.scenes[ViewType.LT].cameraControls.fitToPlane();
		}

		const selectedApex = bindedModel.selectedApex;

		if (stateType >= StateTypes.deformityAnalysis && (bindedModel.isMechanicalAxisAPValid || bindedModel.isMechanicalAxisLTValid || bindedModel.isControlateralMechanicalAxisValid)) {
			bindedModel.selectedApex = SelectedApexMech.none;
			this._main.rotateCamera(RotateCameraType.none);
			printResult.deformity = this.generateImage(PrintStateTypes.deformityAnalysis);
		}

		if (stateType >= StateTypes.RPM && bindedModel.EOCCropVisible) {
			bindedModel.selectedApex = selectedApex;
			this._main.rotateCamera(RotateCameraType.templating);
			printResult.templating = this.generateImage(PrintStateTypes.closeFitboneLock);
		}

		this.restoreData(tempData);

		return printResult;
	}
}
